import React, { useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEnterprise } from '../../contexts/EnterpriseContext';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

export default function FamilyFriendly() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { enterprise, isAuthChecked, surveyProgress, validationStatus, verifyPaper } = useEnterprise() || {};

  useEffect(() => {
    if (isAuthChecked && !enterprise) navigate('/login');
  }, [isAuthChecked, enterprise, navigate]);

  const isQuestionnairePending = surveyProgress !== null && surveyProgress < 2;
  const isValidationPending =
    validationStatus !== null && validationStatus >= 1 && verifyPaper?.editable !== false;

  const questionnaireBadge = isQuestionnairePending
    ? t('ff.nav.badge.pending')
    : isValidationPending
      ? t('ff.nav.badge.validation')
      : null;

  const navItems = [
    { to: '/family-friendly/overview', label: t('ff.nav.overview') },
    {
      to: '/family-friendly/questionnaire',
      label: t('ff.nav.questionnaire'),
      badge: questionnaireBadge,
    },
    { to: '/family-friendly/company-info', label: t('ff.nav.companyInfo') },
  ];

  return (
    <div className="ff-page-container">
      <div className="ff-page">
        <div className="ff-sidebar">
          {navItems.map((item) => {
            const isActive =
              location.pathname === item.to || location.pathname.startsWith(item.to + '/');
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={`ff-sidebar-item ${isActive ? 'ff-sidebar-item--active' : ''}`}
              >
                <span className="ff-sidebar-item-label">{item.label}</span>
                {item.badge && <span className="ff-sidebar-badge">{item.badge}</span>}
              </NavLink>
            );
          })}
        </div>
        <div className="ff-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
